export default {
  getPurchaseTicket: (state) => {
    return state.purchaseTicket;
  },
};

